import cx from 'classnames'
import { find } from 'lodash/fp'
import PropTypes from 'prop-types'
import { ReactNode } from 'react'

import { ProcessItemWithTransferStationId } from '../StorageViz/ProcessItemWithTransferStationId.interface'
import cs from './ot_flex_transfer_station_viz_view.scss'

const DECK_SLOTS = [
  ['A1', 'A2', 'A3', 'A4'],
  ['B1', 'B2', 'B3', 'B4'],
  ['C1', 'C2', 'C3', 'C4'],
  ['D1', 'D2', 'D3', 'D4'],
]

interface OtFlexTransferStationVizViewProps {
  className?: string
  transferStations: ProcessItemWithTransferStationId[]
  renderTransferStation: (
    transferStation: ProcessItemWithTransferStationId | undefined,
  ) => ReactNode
}

const OtFlexTransferStationVizView = ({
  className,
  transferStations,
  renderTransferStation,
}: OtFlexTransferStationVizViewProps) => {
  const renderCell = (deckSlot: string) => {
    const transferStation = find(
      _transferStation => _transferStation.transferStationId === deckSlot,
      transferStations,
    )
    return (
      <div key={deckSlot} className={cs.cell}>
        {renderTransferStation(transferStation)}
      </div>
    )
  }

  return (
    <div className={cx(className, cs.otFlexTransferStationViz)}>
      {DECK_SLOTS.map((row, i) => (
        <div key={i} className={cs.row}>
          {row.map(renderCell)}
        </div>
      ))}
    </div>
  )
}

OtFlexTransferStationVizView.propTypes = {
  className: PropTypes.string,
  transferStations: PropTypes.arrayOf(
    PropTypes.shape({
      transferStationId: PropTypes.string,
    }),
  ),
  renderTransferStation: PropTypes.func,
}

export default OtFlexTransferStationVizView
